module.exports = __webpack_public_path__ + "img/2.0b2dae1c.jpg";